var map = {
	"./icon-7zip.svg": "8878",
	"./icon-7zip_filled.svg": "3ff4",
	"./icon-ai.svg": "f413",
	"./icon-ai_filled.svg": "0cac",
	"./icon-eps.svg": "d54d",
	"./icon-eps_filled.svg": "9394",
	"./icon-excel.svg": "af0c",
	"./icon-excel_filled.svg": "e1ab",
	"./icon-gif.svg": "8eb0",
	"./icon-gif_filled.svg": "6be4",
	"./icon-jpg.svg": "c390",
	"./icon-jpg_filled.svg": "390d",
	"./icon-mp3.svg": "8adf",
	"./icon-mp3_filled.svg": "6fd4",
	"./icon-mp4.svg": "8a5b",
	"./icon-mp4_filled.svg": "cfb1",
	"./icon-pdf.svg": "5794",
	"./icon-pdf_filled.svg": "a600",
	"./icon-png.svg": "9181",
	"./icon-png_filled.svg": "c0a9",
	"./icon-powerpoint.svg": "c028",
	"./icon-ps.svg": "f907",
	"./icon-ps_filled.svg": "1645",
	"./icon-psd.svg": "a4ca",
	"./icon-psd_filled.svg": "5bcc",
	"./icon-svg.svg": "87a4",
	"./icon-svg_filled.svg": "8dcb",
	"./icon-unknow.svg": "80a9",
	"./icon-unknow_filled.svg": "f72b",
	"./icon-word.svg": "2caf",
	"./icon-word_filled.svg": "9dd0",
	"./icon-zip.svg": "8c8a",
	"./icon-zip_filled.svg": "52a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "839a";